module.exports = __webpack_public_path__ + "img/security.9e1625b.svg";